export default {
  SET_MANAGER_LIST_DATA: "managers/SET_MANAGER_LIST_DATA",
  SET_ALL_MANAGER_LIST_DATA: "managers/SET_ALL_MANAGER_LIST_DATA",
  SET_LOADING_STATE: "managers/SET_LOADING_STATE",
  SET_IS_ADD_MANAGER_DIALOG_STATE: "managers/SET_IS_ADD_MANAGER_DIALOG_STATE",
};
